import React, { useState, useContext, useEffect } from "react";
import { Tabs, Collapse } from "antd";
import ConopsCountyDetails from "../conops-countydetails/conopscountydeatils";
import ConopsFacilityDetails from "../conops-facilitydetails/conopsfacilitydetails";
import { ConopsContext } from "../../conops-hooks/ConopsContext";

const { TabPane } = Tabs;
const { Panel } = Collapse;


const ConopsFacilityCountyTabs = () => {
  const { countyObject, registerId, selectedState, selectedCounty } = useContext(ConopsContext);
  const [activeTabKey, setActiveTabKey] = useState('2');
  useEffect(() => {
    // If registerId is present, we force the tab to be '2'
    if (registerId) {
      setActiveTabKey('2');
    }
    // Optionally: If County Details is your fallback when no facility is selected
    else if ((selectedState && selectedCounty) || (countyObject?.county && countyObject?.state)) {
      // Only switch back to '1' if the County tab is available
      setActiveTabKey('1');
    }
  }, [registerId, selectedState, selectedCounty, countyObject]);
  return (
    <div className="card" style={{ padding: "10px" }}>
      <div className="mt-2">
        <Tabs activeKey={activeTabKey} onChange={setActiveTabKey}>
          {((selectedState && selectedCounty) ||
            (countyObject?.county && countyObject?.state)) && (
              <TabPane tab="County Details" key="1">
                <ConopsCountyDetails />
              </TabPane>
            )}

          {registerId && (
            <TabPane tab="Facility Details" key="2">
              <ConopsFacilityDetails />
            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  );
};


export default ConopsFacilityCountyTabs;